import React from 'react';
import ReactDOM from 'react-dom';
import Snowfall from 'react-snowfall';

// Create a new DOM element
const snowContainer = document.createElement('div');
snowContainer.id = 'snow-container'; // Optional: assign an ID for debugging or styling
document.body.appendChild(snowContainer); // Append it to the body

ReactDOM.render(
    <div
        style={{
            height: '100vh', // Full viewport height
            width: '100vw', // Full viewport width
            position: 'fixed', // Fix it to the screen
            top: 0,
            left: 0,
            zIndex: 20, // Layering to keep it above other elements
            pointerEvents: "none" // Ensure it doesn't block user interactions
        }}
    >
        <Snowfall />
    </div>,
    snowContainer // Use the newly created DOM element
);